<div class="countainer">
    <img class="countainer_image" src="../../../../assets/images/IpadRotation.gif" alt="">
    <span class="countainer_text">Pour une meilleure expérience. Merci de pivoter l'Ipad</span>
</div>